import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M415.2 254.2c.5.5.8 1.1.8 1.8s-.3 1.4-.8 1.8L283.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8-3.7 0-6.7-3-6.7-6.7V320c0-8.8-7.2-16-16-16H136c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h120c8.8 0 16-7.2 16-16v-57.3c0-3.7 3-6.7 6.7-6.7 1.7 0 3.3.7 4.6 1.8zM448 256c0-9.5-3.9-18.6-10.8-25.1l-132-124.4C298 99.8 288.5 96 278.7 96c-21.4 0-38.7 17.3-38.7 38.7V176H136c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h104v41.3c0 21.4 17.3 38.7 38.7 38.7 9.9 0 19.3-3.8 26.5-10.5l132-124.4c6.9-6.5 10.8-15.6 10.8-25.1M0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16S0 71.2 0 80"
    }, null, -1)
  ])))
}
export default { render: render }